export default "__VITE_ASSET__Cr8OFwrb__"